// A payee needs an email (required by the payment provider to create the payout
// contact), an ABN, and bank details before a bill can be paid.
export const hasMissingPayeeDetails = (payee) =>
  !payee?.email ||
  !payee?.businessNumber ||
  !payee?.bankAccount?.bsb ||
  !payee?.bankAccount?.accountNumber
